import { logWrapper } from '../../utils';
import swal from 'sweetalert2';

export default {
  recoverPasswordController: [
    'runtimeConstant',
    '$scope',
    '$rootScope',
    '$window',
    'authService',
    '$state',
    '$timeout',
    '$filter',
    '$uibModal',
    function (
      runtimeConstant,
      $scope,
      $rootScope,
      $window,
      authService,
      $state,
      $timeout,
      $filter
    ) {
      'use strict';

      function keyPress(e) {
        // keyCode == ENTER
        if (e.keyCode === 13) {
          $scope.recoverPassword();
        }
      }

      function is390Visible() {
        var width = $window.innerWidth;
        return width > 767 || (width <= 600 && width > 500);
      }

      function is500Visible() {
        var width = $window.innerWidth;
        return width <= 767 && width > 600;
      }

      function is300Visible() {
        var width = $window.innerWidth;
        return width <= 500 && width > 400;
      }

      function is220Visible() {
        var width = $window.innerWidth;
        return width <= 400;
      }

      function recoverPassword() {
        authService
          .recoverPassword(
            $scope.recoverForm.password1.$modelValue,
            $scope.token
          )
          .then(() => {
            $state.go('login');
          })
          .catch((error) => {
            swal.fire({
              title: $filter('translate')('UNEXPECTED ERROR'),
              text: error,
              icon: 'warning',
              showCancelButton: false,
              closeOnConfirm: false,
            });
          });
      }

      function invalidPassLength() {
        if ($scope.recoverForm.password1.$viewValue.length < 5) {
          return true;
        }
        $scope.message.msg = '';
        return false;
      }

      function invalidPassDiff() {
        if (
          $scope.recoverForm.password1.$modelValue !==
          $scope.recoverForm.password2.$modelValue
        ) {
          return true;
        }

        return false;
      }

      function init() {
        try {
          if ($state && $state.params && $state.params.token) {
            $scope.token = $state.params.token;
          } else {
            $scope.msgError();
          }

          var expireAt = authService.getTokenExpirationDate($scope.token);
          if (expireAt < new Date()) {
            $scope.msgError();
          }
        } catch {
          $scope.msgError();
        }
      }

      function msgError() {
        $timeout(function () {
          swal
            .fire({
              title: $filter('translate')('FAILED RECOVER'),
              text: $filter('translate')('ACCESS EXPIRED'),
              icon: 'error',
            })
            .then(function () {
              $timeout(function () {
                $state.go('forgotPassword');
              });
            });
        });
      }

      function run() {
        try {
          $rootScope.onLogin = true;
          $rootScope.title = '- recoverPasswordController';
          $scope.pass1 = '';
          $scope.pass2 = '';
          $scope.message = { msg: '' };
          $scope.idle = false;

          $scope.keyPress = logWrapper(
            keyPress,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.is390Visible = logWrapper(
            is390Visible,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.is500Visible = logWrapper(
            is500Visible,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.is300Visible = logWrapper(
            is300Visible,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.is220Visible = logWrapper(
            is220Visible,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.recoverPassword = logWrapper(
            recoverPassword,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.invalidPassLength = logWrapper(
            invalidPassLength,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.invalidPassDiff = logWrapper(
            invalidPassDiff,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.init = logWrapper(
            init,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.msgError = logWrapper(
            msgError,
            runtimeConstant.isDebugControllersInternals
          );

          $scope.init();
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      logWrapper(run, runtimeConstant.isDebugControllers)();
    },
  ],
};
